import React from 'react';
import { Card } from 'primereact/card';

const TermsAndConditionsContent = ({ showHeroCards = true, isDashboard = false }) => {
    const refundPolicyLink = isDashboard ? '/app/legal/refund' : '/app/refund-policy';
    return (
        <div>
            {/* Key Points Cards - Optional for dashboard version */}
            {showHeroCards && (
                <div className="grid mb-6">
                    <div className="col-12 md:col-4">
                        <Card className="h-full text-center shadow-4 border-round-xl hover:shadow-8 transition-all transition-duration-300">
                            <div className="inline-flex align-items-center justify-content-center mb-3" 
                                 style={{
                                     width: '60px',
                                     height: '60px',
                                     borderRadius: '12px',
                                     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                 }}>
                                <i className="pi pi-verified text-white text-2xl"></i>
                            </div>
                            <h4 className="font-bold mb-2">Legal Agreement</h4>
                            <p className="text-600 m-0">Binding terms between you and Hireka Services</p>
                        </Card>
                    </div>
                    
                    <div className="col-12 md:col-4">
                        <Card className="h-full text-center shadow-4 border-round-xl hover:shadow-8 transition-all transition-duration-300">
                            <div className="inline-flex align-items-center justify-content-center mb-3" 
                                 style={{
                                     width: '60px',
                                     height: '60px',
                                     borderRadius: '12px',
                                     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                 }}>
                                <i className="pi pi-credit-card text-white text-2xl"></i>
                            </div>
                            <h4 className="font-bold mb-2">Secure Payments</h4>
                            <p className="text-600 m-0">Powered by Razorpay with tokenized security</p>
                        </Card>
                    </div>
                    
                    <div className="col-12 md:col-4">
                        <Card className="h-full text-center shadow-4 border-round-xl hover:shadow-8 transition-all transition-duration-300">
                            <div className="inline-flex align-items-center justify-content-center mb-3" 
                                 style={{
                                     width: '60px',
                                     height: '60px',
                                     borderRadius: '12px',
                                     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                 }}>
                                <i className="pi pi-balance-scale text-white text-2xl"></i>
                            </div>
                            <h4 className="font-bold mb-2">Indian Law</h4>
                            <p className="text-600 m-0">Governed by laws of India, Bengaluru jurisdiction</p>
                        </Card>
                    </div>
                </div>
            )}

            {/* Terms Sections */}
            <div className="grid">
                <div className="col-12">
                    {/* Section 1: Parties */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-blue-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-users text-blue-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">1. Parties</h2>
                        </div>
                        <p className="text-lg text-700 line-height-3">
                            This Agreement is between <strong>Hireka Services Pvt. Ltd.</strong> ("Company", "we", "us") and 
                            users of interestng.com ("you", "your"). By accessing our site or using our services, 
                            you agree to these Terms and Conditions in their entirety.
                        </p>
                    </Card>

                    {/* Section 2: Services */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-green-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-briefcase text-green-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">2. Services</h2>
                        </div>
                        <div className="surface-50 border-round-lg p-4">
                            <h4 className="font-bold mb-3">What We Provide</h4>
                            <div className="grid">
                                <div className="col-12 md:col-6">
                                    <div className="flex align-items-start mb-3">
                                        <i className="pi pi-cloud text-primary mr-2 mt-1"></i>
                                        <span className="text-lg text-700">Cloud-based loan origination platform</span>
                                    </div>
                                </div>
                                <div className="col-12 md:col-6">
                                    <div className="flex align-items-start mb-3">
                                        <i className="pi pi-code text-primary mr-2 mt-1"></i>
                                        <span className="text-lg text-700">API services for verification</span>
                                    </div>
                                </div>
                                <div className="col-12 md:col-6">
                                    <div className="flex align-items-start mb-3">
                                        <i className="pi pi-star text-primary mr-2 mt-1"></i>
                                        <span className="text-lg text-700">Features based on subscription tier</span>
                                    </div>
                                </div>
                                <div className="col-12 md:col-6">
                                    <div className="flex align-items-start mb-3">
                                        <i className="pi pi-wallet text-primary mr-2 mt-1"></i>
                                        <span className="text-lg text-700">Razorpay subscription payment required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 3: Eligibility & Account Security */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-purple-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-shield text-purple-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">3. Eligibility & Account Security</h2>
                        </div>
                        <div className="grid">
                            <div className="col-12 lg:col-6">
                                <div className="surface-50 border-round-lg p-4 h-full">
                                    <h4 className="font-bold mb-3">
                                        <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                        Eligibility Requirements
                                    </h4>
                                    <p className="text-lg text-700 m-0">
                                        Users must be competent to contract under Indian Contract Act 1872
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 lg:col-6">
                                <div className="surface-50 border-round-lg p-4 h-full">
                                    <h4 className="font-bold mb-3">
                                        <i className="pi pi-lock text-blue-500 mr-2"></i>
                                        Your Responsibility
                                    </h4>
                                    <p className="text-lg text-700 m-0">
                                        Users are responsible for account credentials and all activity
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 4: Fees, Taxes & Payment */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-orange-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-wallet text-orange-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">4. Fees, Taxes & Payment Gateway</h2>
                        </div>
                        <div className="grid">
                            <div className="col-12 md:col-4">
                                <div className="text-center p-4">
                                    <i className="pi pi-indian-rupee text-4xl text-primary mb-3"></i>
                                    <h4 className="font-bold mb-2">Pricing</h4>
                                    <p className="text-700">Prices in Indian Rupees</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-4">
                                <div className="text-center p-4">
                                    <i className="pi pi-sync text-4xl text-primary mb-3"></i>
                                    <h4 className="font-bold mb-2">Recurring</h4>
                                    <p className="text-700">Automatic recurring payments via Razorpay</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-4">
                                <div className="text-center p-4">
                                    <i className="pi pi-lock text-4xl text-primary mb-3"></i>
                                    <h4 className="font-bold mb-2">Security</h4>
                                    <p className="text-700">Card data tokenized, not stored on servers</p>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 5: Refunds & Cancellations */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-cyan-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-refresh text-cyan-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">5. Refunds & Cancellations</h2>
                        </div>
                        <div className="surface-50 border-round-lg p-4 text-center">
                            <i className="pi pi-info-circle text-3xl text-blue-500 mb-3"></i>
                            <p className="text-lg text-700 mb-3">
                                For detailed information on refunds and cancellations
                            </p>
                            <a href={refundPolicyLink} className="text-primary text-lg font-bold no-underline hover:underline">
                                View our Refund & Cancellation Policy →
                            </a>
                        </div>
                    </Card>

                    {/* Section 6: Intellectual Property */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-indigo-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-lock text-indigo-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">6. Intellectual Property</h2>
                        </div>
                        <div className="grid">
                            <div className="col-12 md:col-6">
                                <div className="flex align-items-start mb-3">
                                    <i className="pi pi-building text-primary text-xl mr-3 mt-1"></i>
                                    <div>
                                        <h4 className="font-bold mb-2">Company Retains</h4>
                                        <p className="text-700">All source code, trademarks, and content</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 md:col-6">
                                <div className="flex align-items-start mb-3">
                                    <i className="pi pi-user text-primary text-xl mr-3 mt-1"></i>
                                    <div>
                                        <h4 className="font-bold mb-2">Users Receive</h4>
                                        <p className="text-700">Limited, non-transferable SaaS license</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 7: Limitation of Liability */}
                    <Card className="mb-4 shadow-2 border-round-xl" style={{ borderLeft: '4px solid #ef4444' }}>
                        <div className="flex align-items-center mb-4">
                            <div className="bg-red-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-exclamation-triangle text-red-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">7. Limitation of Liability</h2>
                        </div>
                        <div className="bg-red-50 border-round-lg p-4 text-center">
                            <i className="pi pi-info-circle text-3xl text-red-500 mb-3"></i>
                            <p className="text-lg text-900 font-bold mb-2">Important Notice</p>
                            <p className="text-lg text-700">
                                Maximum liability limited to <strong>one month of subscription fees</strong> prior to claim
                            </p>
                        </div>
                    </Card>

                    {/* Section 8: Governing Law */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-teal-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-balance-scale text-teal-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">8. Governing Law & Dispute Resolution</h2>
                        </div>
                        <div className="grid">
                            <div className="col-12 md:col-6">
                                <div className="surface-50 border-round-lg p-4 h-full text-center">
                                    <i className="pi pi-flag text-3xl text-primary mb-3"></i>
                                    <h4 className="font-bold mb-2">Indian Law</h4>
                                    <p className="text-700 m-0">Terms governed by laws of India</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-6">
                                <div className="surface-50 border-round-lg p-4 h-full text-center">
                                    <i className="pi pi-map-marker text-3xl text-primary mb-3"></i>
                                    <h4 className="font-bold mb-2">Jurisdiction</h4>
                                    <p className="text-700 m-0">Bengaluru, Karnataka courts have exclusive jurisdiction</p>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 9: Updates */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-pink-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-sync text-pink-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">9. Updates to Terms</h2>
                        </div>
                        <div className="surface-50 border-round-lg p-4">
                            <div className="flex align-items-start">
                                <i className="pi pi-info-circle text-blue-500 text-xl mr-3 mt-1"></i>
                                <div>
                                    <p className="text-lg text-700 mb-2">
                                        Terms may be revised periodically to reflect changes in our services or legal requirements.
                                    </p>
                                    <p className="text-lg text-700 font-bold m-0">
                                        Continued use after the "Last updated" date constitutes acceptance of revised terms.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Contact Section */}
                    <Card className="shadow-2 border-round-xl" style={{ 
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                    }}>
                        <div className="text-center text-white">
                            <i className="pi pi-headphones text-5xl mb-4 opacity-90"></i>
                            <h2 className="text-3xl font-bold mb-4">Need Help?</h2>
                            <p className="text-lg mb-4 opacity-95">
                                If you have any questions about these Terms and Conditions, please contact us:
                            </p>
                            <div className="flex justify-content-center gap-4 flex-wrap">
                                <div className="bg-white-alpha-20 border-round-lg p-3">
                                    <i className="pi pi-envelope mr-2"></i>
                                    <span className="font-bold">tech@interestng.com</span>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditionsContent;